import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { initValueAccount } from '../../shared/initials';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { fetchDataAndUpdateStore, singleRowAddUpdateInStore } from '../../redux/actions';
import { getGridDataByModuleKey, getUser } from '../../redux/selector';
import AccountForm from './accountForm';
import { validationSchemaAccount } from './validationSchema';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import { accountInputData, dropdownPayload } from '../../shared/constants';

const AddAccountsForm = () => {
  const stateData = useSelector((state) => state);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(
    stateData,
    'revenueTypeList',
    'leadSourceList',
    'industryList',
    'timeZone'
  );

  const location = useLocation();
  const userInfo = useSelector(getUser);
  console.log('userInfo', userInfo);
  // Update owner in initValueLead if it is an empty string
  if (!initValueAccount.owner) {
    initValueAccount.owner = userInfo?.user?.display_name;
    initValueAccount.ownerId = userInfo?.user?.userId;
  }
  const [formData, setFormData] = useState(initValueAccount);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [loading, setLoading] = useState(storeLoading);
  const [imagefile, setImageFile] = useState(null);
  const [imageUploadStatus, setImageUploadStatus] = useState(false);
  const navigate = useNavigate();
  const gridData = useSelector(getGridDataByModuleKey('accountList'));

  const handleCloseAddForm = () => {
    if(formData?.from === "view"){
      navigate(`/accounts/viewAccount?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`)
    } else
    navigate('/accounts');
  };

  const handleUploadImage = async (imagefile) => {
    setImageFile(imagefile);
    setFormEdited(true);
  };

  const saveUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id.data, {
        type: imagefile.type,
      });
      let status = await apiServices.uploadLeadImageCRM(newFile, 'Account');
      setImageUploadStatus(status);
    }
  };

  const editUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id, {
        type: imagefile.type,
      });
      let status = await apiServices.uploadLeadImageCRM(newFile, 'Account');
      setImageUploadStatus(status);
    }
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    let convertedValue = value;
    // Allow only numbers, +, -, (), and space for phone-related fields
    if (['phone', 'mobile', 'alternatePhone'].includes(name)) {
      convertedValue = value.replace(/[^0-9+\-() ]/g, '');
    }
    // Employees: allow only digits and convert to int, or null if empty
    if (name === 'employees') {
      if (value.trim() === '') {
        convertedValue = null;
      } else {
        convertedValue = value.replace(/[^0-9]/g, '');
        if (convertedValue !== '') {
          convertedValue = parseInt(convertedValue, 10);
        }
      }
    }
    // No of Beds: allow only digits but keep as string
    if (name === 'noOfBeds') {
      convertedValue = value.replace(/[^0-9]/g, '');
    }
    // Annual Revenue: allow digits + one dot, max 2 decimal places, or null if empty
    if (name === 'annualRevenue') {
      if (value.trim() === '') {
        convertedValue = null;
      } else {
        convertedValue = value.replace(/[^0-9.]/g, '');
        const parts = convertedValue.split('.');
        if (parts.length > 2) {
          convertedValue = parts[0] + '.' + parts.slice(1).join('');
        }
        if (convertedValue.includes('.')) {
          convertedValue = parts[0] + '.' + (parts[1] || '').substring(0, 2);
        }
        if (!isNaN(convertedValue)) {
          convertedValue = parseFloat(convertedValue);
        }
      }
    }
    // Clear error for the edited field
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    // Update form data
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
    setFormEdited(true);
  };
  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    if (name === 'industryId') {
      setFormData({
        ...formData,
        industryId: selectedId,
        industry: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'accountTypeId') {
      setFormData({
        ...formData,
        accountTypeId: selectedId,
        accountType: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'parentAccountId') {
      setFormData({
        ...formData,
        parentAccountId: selectedId,
        parentAccount: selectedValue,
      });
      setFormEdited(true);
    }
  };

  const updateList = async (msg, id) => {
    setLoading(false);
    toast.success(msg, {
      position: 'top-right',
    });
    try {
      // ✅ Await the dispatch before navigation
      //  await dispatch(
      //   fetchDataAndUpdateStore({
      //     key: "accountList",
      //     inputData: accountInputData,
      //   })
      // );

      dispatch(
        singleRowAddUpdateInStore({
          moduleName: 'Account',
          id: formData.type === 'add' ? id : formData.id,
          rowIndex: formData.rowIndex,
        })
      );
      dispatch(
        fetchDataAndUpdateStore({
          key: 'accountDropdown',
          inputData: dropdownPayload,
        })
      );
      if (formData.from === 'view') {
        navigate(
          `/accounts/viewAccount?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`
        );
      } else {
        navigate('/accounts');
      }
    } catch (error) {
      console.error('Failed to fetch and update Account:', error);
      toast.error('Something went wrong while updating the list.', {
        position: 'top-right',
      });
    }
  };

  const handleSubmit = async (formData) => {
    try {
      // Remove "https://" and "www." from relevant fields
      const sanitizedData = {
        ...formData,
        website: formData?.website?.replace(/^(https?:\/\/)?(www\.)?/, ''), // Remove protocol and www from website
        companyLinkedIn: formData?.companyLinkedIn?.replace(/^(https?:\/\/)?(www\.)?/, ''), // Remove protocol and www from companyLinkedIn
      };

      await validationSchemaAccount.validate(sanitizedData, {
        abortEarly: false,
      });
      handleFormSubmit(sanitizedData);
    } catch (error) {
      const fieldErrors = {};
      error?.inner?.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  const handleFormSubmit = (formData) => {
    setLoading(true);
    if (formData.type === 'add') {
      apiServices
        .createAccountList(formData)
        .then((response) => {
          if (response.status === 200) {
            saveUploadImage(response);
            const id = response.data;
            updateList('Account created successfully!', id);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    } else {
      editUploadImage(formData.id);
      apiServices
        .updateAccountList(formData)
        .then((response) => {
          if (response.status === 200) {
            updateList('Account updated successfully!');
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    let updatedFormData = {
      ...formData,
      type: location.pathname.includes('addAccount') ? 'add' : 'edit',
    };
    if (location.pathname.includes('editAccount') && location.state) {
      updatedFormData = {
        ...location.state,
        type: 'edit',
      };
    }
    setFormData(updatedFormData);
  }, [location]);

  return (
    <div className="addlead_container">
      <div className="viewHeader">
        <HeaderProfileBlock
          localData={formData}
          moduleName={'Account'}
          uploadFile={handleUploadImage}
        />

        <div className="rightAction">
          <button
            type="button"
            className="btn btn-outline-primary"
            data-bs-dismiss="modal"
            onClick={handleCloseAddForm}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              handleSubmit(formData);
            }}
            disabled={loading || (formData.type === 'edit' && !formEdited)}
          >
            {loading && (
              <>
                {' '}
                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
              </>
            )}
            {loading ? 'Loading...' : 'Save'}
          </button>
        </div>
      </div>
      {formData && (
        <AccountForm
          formData={formData}
          handleSubmit={handleSubmit}
          handleChangeForm={handleChangeForm}
          handleChange={handleChange}
          errormsg={errormsg}
          selectedOptions={selectedOptions}
        />
      )}
    </div>
  );
};

export default AddAccountsForm;
